// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  color: var(--ion-color-subtitle);
  text-align: left !important;
}

.container {
  overflow: auto;
}

.default-img {
  border-radius: 4px;
  padding: 20px;
  object-fit: contain;
  height: 200px !important;
}

.article-info {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.article-info ion-img {
  height: 150px;
  margin-bottom: 16px;
}
.article-info .name {
  font-family: AppFontTitle;
  font-size: 26px;
  line-height: 100%;
  letter-spacing: -0.01em;
  text-transform: uppercase;
  padding-bottom: 16px;
}
.article-info .desc {
  font-family: AppFont;
  font-size: 14px;
  line-height: 21px;
  text-align: center;
  color: rgba(47, 51, 58, 0.6980392157);
  margin-bottom: 16px;
}
.article-info .desc ::ng-deep p {
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  text-align: inherit;
  color: inherit;
}
.article-info .info ::ng-deep p {
  font-family: AppFont;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
  margin-bottom: 30px;
}

.nutrition-title {
  font-family: AppFontBold;
  font-size: 14px;
  line-height: 18.27px;
  text-align: start !important;
  color: var(--color-black);
  margin-bottom: 20px;
}

.nutrition-subtitle {
  font-family: AppFontTitle;
  font-size: 18px;
  line-height: 100%;
  letter-spacing: -0.01em;
  text-transform: uppercase;
  padding-top: 16px;
  margin-bottom: 12px;
  border-top: 1px solid rgba(112, 113, 115, 0.2);
}

.nutrition-name,
.nutrition-value {
  font-family: AppFont;
  font-size: 14px;
  font-weight: 500;
  line-height: 18.27px;
  text-align: left;
  color: var(--color-black);
}

.nutrition-value {
  text-align: end !important;
  text-transform: lowercase;
}

.compaunds {
  overflow: auto;
  height: 240px;
}

p {
  line-height: 22px;
}

h1 {
  margin: 0;
  padding: 0 4px;
}

ul {
  padding: 0px;
  padding-left: 26px;
  -webkit-text-decoration: dotted;
          text-decoration: dotted;
  list-style-type: revert;
  margin: 0px 0px 10px 0px;
}

li {
  text-decoration: none;
  text-align: left;
  color: var(--color-black);
  font-size: 14px;
  margin-bottom: 12px;
}
li:last-child {
  margin-bottom: 0;
}

ion-icon {
  width: 48px;
  height: 48px;
}

h3 {
  font-size: 16px;
  font-family: AppFontBold, sans-serif;
  letter-spacing: 0px;
  color: var(--color-black);
}

.button-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 16px 12px;
  width: 100%;
  box-shadow: 3px 0px 45px 0px rgba(0, 0, 0, 0.0705882353);
}

.footer-info {
  font-family: AppFont;
  font-size: 16px;
  line-height: 150%;
  letter-spacing: 0.02em;
  text-transform: capitalize;
  color: #072633;
  padding-bottom: 12px;
  border-bottom: 1px solid #dce8f5;
  margin-bottom: 12px;
}

.inner-text {
  text-align: left;
  color: var(--color-black);
  font-size: 14px;
  margin: 5px 0 6px;
}

.line {
  width: 100%;
  height: 3px;
  margin: 10px 0px;
  fill: var(--ion-color-primary);
}

.cross {
  width: 24px;
  height: 24px;
  margin-right: 5px;
  margin-bottom: 5px;
}

.button-text {
  font-family: AppFontBold, sans-serif;
  font-size: 18px;
  color: var(--ion-color-secondary);
}

.nutrition-value {
  text-align: right !important;
}

.nutrition ion-row {
  padding: 0;
  margin-left: -3px;
}
.nutrition ion-row:first-of-type {
  margin-top: 10px;
}
.nutrition ion-col {
  padding: 5px;
}

.overflow-auto {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.content-block {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: auto;
  padding: 52px 18px 18px;
  background-color: #fff;
  flex-grow: 1;
}

.cross {
  --icon-color: var(--color-black);
  height: 19px;
  width: 19px;
  margin-left: auto;
  position: absolute;
  right: 20px;
  top: 20px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/short-info-modal/short-info-modal.component.scss"],"names":[],"mappings":"AAEA;EACC,gCAAA;EACA,2BAAA;AADD;;AAIA;EAEC,cAAA;AAFD;;AAMA;EACC,kBAAA;EACA,aAAA;EACA,mBAAA;EAEA,wBAAA;AAJD;;AAOA;EACC,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;AAJD;AAKC;EACC,aAAA;EACA,mBAAA;AAHF;AAKC;EACC,yBAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,yBAAA;EACA,oBAAA;AAHF;AAKC;EACC,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,qCAAA;EACA,mBAAA;AAHF;AAIE;EACC,oBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;AAFH;AAOG;EACC,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;AALJ;;AAWA;EACC,wBAAA;EACA,eAAA;EACA,oBAAA;EACA,4BAAA;EACA,yBAAA;EACA,mBAAA;AARD;;AAWA;EACC,yBAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,yBAAA;EAEA,iBAAA;EACA,mBAAA;EACA,8CAAA;AATD;;AAYA;;EAEC,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;EACA,yBAAA;AATD;;AAYA;EACC,0BAAA;EACA,yBAAA;AATD;;AAYA;EACC,cAAA;EACA,aAAA;AATD;;AAYA;EACC,iBAAA;AATD;;AAYA;EACC,SAAA;EACA,cAAA;AATD;;AAWA;EACC,YAAA;EACA,kBAAA;EACA,+BAAA;UAAA,uBAAA;EACA,uBAAA;EACA,wBAAA;AARD;;AAUA;EACC,qBAAA;EACA,gBAAA;EACA,yBAAA;EACA,eAAA;EACA,mBAAA;AAPD;AASC;EACC,gBAAA;AAPF;;AAUA;EACC,WAAA;EACA,YAAA;AAPD;;AAmBA;EACC,eAAA;EACA,oCAAA;EACA,mBAAA;EACA,yBAAA;AAhBD;;AAkBA;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,wDAAA;AAfD;;AAiBA;EACC,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,0BAAA;EACA,cAAA;EACA,oBAAA;EACA,gCAAA;EACA,mBAAA;AAdD;;AAgBA;EACC,gBAAA;EACA,yBAAA;EACA,eAAA;EACA,iBAAA;AAbD;;AAeA;EACC,WAAA;EACA,WAAA;EACA,gBAAA;EACA,8BAAA;AAZD;;AAcA;EACC,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AAXD;;AAaA;EACC,oCAAA;EACA,eAAA;EACA,iCAAA;AAVD;;AAYA;EACC,4BAAA;AATD;;AAaC;EACC,UAAA;EACA,iBAAA;AAVF;AAYE;EACC,gBAAA;AAVH;AAaC;EACC,YAAA;AAXF;;AAcA;EACC,kBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AAXD;;AAaA;EACC,aAAA;EACA,sBAAA;EAEA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,sBAAA;EACA,YAAA;AAXD;;AAcA;EACC,gCAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;AAXD","sourcesContent":["@use '../../../theme/mixins' as *;\n\n* {\n\tcolor: var(--ion-color-subtitle);\n\ttext-align: left !important;\n}\n\n.container {\n\t// max-height: 80vh;\n\toverflow: auto;\n\n\t// padding-bottom: 80px;\n}\n.default-img {\n\tborder-radius: 4px;\n\tpadding: 20px;\n\tobject-fit: contain;\n\t// background-color: var(--ion-color-primary);\n\theight: 200px !important;\n}\n\n.article-info {\n\tdisplay: flex;\n\tjustify-content: center;\n\tflex-direction: column;\n\talign-items: center;\n\tion-img {\n\t\theight: 150px;\n\t\tmargin-bottom: 16px;\n\t}\n\t.name {\n\t\tfont-family: AppFontTitle;\n\t\tfont-size: 26px;\n\t\tline-height: 100%;\n\t\tletter-spacing: -0.01em;\n\t\ttext-transform: uppercase;\n\t\tpadding-bottom: 16px;\n\t}\n\t.desc {\n\t\tfont-family: AppFont;\n\t\tfont-size: 14px;\n\t\tline-height: 21px;\n\t\ttext-align: center;\n\t\tcolor: #2f333ab2;\n\t\tmargin-bottom: 16px;\n\t\t::ng-deep p {\n\t\t\tfont-family: inherit;\n\t\t\tfont-size: inherit;\n\t\t\tline-height: inherit;\n\t\t\ttext-align: inherit;\n\t\t\tcolor: inherit;\n\t\t}\n\t}\n\t.info {\n\t\t::ng-deep {\n\t\t\tp {\n\t\t\t\tfont-family: AppFont;\n\t\t\t\tfont-size: 12px;\n\t\t\t\tline-height: 18px;\n\t\t\t\ttext-align: center;\n\t\t\t\tmargin-bottom: 30px;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.nutrition-title {\n\tfont-family: AppFontBold;\n\tfont-size: 14px;\n\tline-height: 18.27px;\n\ttext-align: start !important;\n\tcolor: var(--color-black);\n\tmargin-bottom: 20px;\n}\n\n.nutrition-subtitle {\n\tfont-family: AppFontTitle;\n\tfont-size: 18px;\n\tline-height: 100%;\n\tletter-spacing: -0.01em;\n\ttext-transform: uppercase;\n\n\tpadding-top: 16px;\n\tmargin-bottom: 12px;\n\tborder-top: 1px solid #70717333;\n}\n\n.nutrition-name,\n.nutrition-value {\n\tfont-family: AppFont;\n\tfont-size: 14px;\n\tfont-weight: 500;\n\tline-height: 18.27px;\n\ttext-align: left;\n\tcolor: var(--color-black);\n}\n\n.nutrition-value {\n\ttext-align: end !important;\n\ttext-transform: lowercase;\n}\n\n.compaunds {\n\toverflow: auto;\n\theight: 240px;\n}\n\np {\n\tline-height: 22px;\n}\n\nh1 {\n\tmargin: 0;\n\tpadding: 0 4px;\n}\nul {\n\tpadding: 0px;\n\tpadding-left: 26px;\n\ttext-decoration: dotted;\n\tlist-style-type: revert;\n\tmargin: 0px 0px 10px 0px;\n}\nli {\n\ttext-decoration: none;\n\ttext-align: left;\n\tcolor: var(--color-black);\n\tfont-size: 14px;\n\tmargin-bottom: 12px;\n\n\t&:last-child {\n\t\tmargin-bottom: 0;\n\t}\n}\nion-icon {\n\twidth: 48px;\n\theight: 48px;\n}\n\n// ion-row {\n//   padding: 8px;\n\n//   text-align: center;\n\n//   ion-col {\n//     padding: 12px;\n//   }\n// }\nh3 {\n\tfont-size: 16px;\n\tfont-family: AppFontBold, sans-serif;\n\tletter-spacing: 0px;\n\tcolor: var(--color-black);\n}\n.button-block {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tjustify-content: center;\n\tpadding: 16px 12px;\n\twidth: 100%;\n\tbox-shadow: 3px 0px 45px 0px #00000012;\n}\n.footer-info {\n\tfont-family: AppFont;\n\tfont-size: 16px;\n\tline-height: 150%;\n\tletter-spacing: 0.02em;\n\ttext-transform: capitalize;\n\tcolor: #072633;\n\tpadding-bottom: 12px;\n\tborder-bottom: 1px solid #dce8f5;\n\tmargin-bottom: 12px;\n}\n.inner-text {\n\ttext-align: left;\n\tcolor: var(--color-black);\n\tfont-size: 14px;\n\tmargin: 5px 0 6px;\n}\n.line {\n\twidth: 100%;\n\theight: 3px;\n\tmargin: 10px 0px;\n\tfill: var(--ion-color-primary);\n}\n.cross {\n\twidth: 24px;\n\theight: 24px;\n\tmargin-right: 5px;\n\tmargin-bottom: 5px;\n}\n.button-text {\n\tfont-family: AppFontBold, sans-serif;\n\tfont-size: 18px;\n\tcolor: var(--ion-color-secondary);\n}\n.nutrition-value {\n\ttext-align: right !important;\n}\n\n.nutrition {\n\tion-row {\n\t\tpadding: 0;\n\t\tmargin-left: -3px;\n\n\t\t&:first-of-type {\n\t\t\tmargin-top: 10px;\n\t\t}\n\t}\n\tion-col {\n\t\tpadding: 5px;\n\t}\n}\n.overflow-auto {\n\tposition: relative;\n\twidth: 100%;\n\theight: 100%;\n\toverflow: hidden;\n\tdisplay: flex;\n\tflex-direction: column;\n}\n.content-block {\n\tdisplay: flex;\n\tflex-direction: column;\n\t// height: calc(100% - 75px);\n\theight: 100%;\n\toverflow-y: auto;\n\tpadding: 52px 18px 18px;\n\tbackground-color: #fff;\n\tflex-grow: 1;\n}\n\n.cross {\n\t--icon-color: var(--color-black);\n\theight: 19px;\n\twidth: 19px;\n\tmargin-left: auto;\n\tposition: absolute;\n\tright: 20px;\n\ttop: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
